
/**
 * ノーコード（rule_tree）で作ったチェックリストの抽出条件。
 *
 * **文言はBEが組み立てて返す。ここは受け取って並べるだけ。**
 * フロントが V1(Vue2) と V2(Next.js) の2つあるため、文言を両方に持つと
 * 片方だけ直す事故が起きる。
 *
 * 見た目は確認済みのUIプロトタイプ（`todo/tickets/ui.html`）に合わせている:
 * 見出しは枠付きのCallout、グループはグレー帯の見出し付きセクション、値はチップ。
 * ⚠️ `@chemican/components` は React 専用でここからは使えないため、
 * 同じ見え方になるスタイルを自前で当てている。
 */
import Vue, { PropType } from 'vue';
import ExcludeItemBody from '@/views/pages/dynamicList/ExcludeItemBody.vue';
import ExtractionConditionGroup from '@/views/pages/dynamicList/ExtractionConditionGroup.vue';
import { ExtractionConditions } from '@/views/pages/dynamicList/extractionConditions';

export default Vue.extend({
  name: 'ExtractionConditionsPanel',
  components: { ExcludeItemBody, ExtractionConditionGroup },
  props: {
    conditions: {
      type: Object as PropType<ExtractionConditions>,
      required: true,
    },
  },
  computed: {
    hasExcludes(): boolean {
      const excludes = this.conditions.excludes;
      return !!(excludes && excludes.items && excludes.items.length > 0);
    },
  },
});
